import React from 'react';
import {Heading} from '../../components/guide/Heading';
import CtaBanner from "../../components/guide/CtaBanner";
import HeaderPath from "../../components/common/HeaderPath";
import BoxImg1 from "../../assets/images/card/cf_box_img1.png";
import WhyContentIcon1 from "../../assets/images/icon/why_content_icon_1.svg";
import WhyContentIcon2 from "../../assets/images/icon/why_content_icon_2.svg";
import WhyContentIcon3 from "../../assets/images/icon/why_content_icon_3.svg";
import WhyContentIcon4 from "../../assets/images/icon/why_content_icon_4.svg";
import WhyContentIcon5 from "../../assets/images/icon/why_content_icon_5.svg";
import CfVideo1 from "../../assets/videos/cf_video_1.mp4";
import CfVideo2 from "../../assets/videos/cf_video_2.mp4";
import CfVideo3 from "../../assets/videos/cf_video_3.mp4";
import CfVideo4 from "../../assets/videos/cf_video.mp4";


const CfContentPage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 콘텐츠 제작 > 분양의신 CF 배너 시스템'}/>
            <Heading className="hidden lg:block lg:mt-[93px] lg:mb-[96px]" as="h1" size="h1">
                분양의신 CF 배너 시스템
            </Heading>
            <div className="mt-0 flex flex-col gap-12 sm:gap-16 lg:mt-0 lg:gap-[93px]">
                <Heading as="p" size="subtitle" className="text-black font-[400] leading-relaxed">
                    분양 현장들은 홍보 영상, 항공 촬영, 단지 소개 영상 등 이미 잘 만든 영상을 많이 갖고 있습니다.<br/>
                    하지만 그 영상들이 광고로 연결되는 경우는 거의 없습니다. 우리는 그 부분이 늘 아쉬웠습니다.<br/>
                    <br/>
                    그래서, 우리가 시작했습니다.
                </Heading>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">우리는 이렇게 만듭니다.</h5>
                    <Heading as="p" size="subtitle" className="mt-5 text-black font-[400] leading-relaxed sm:mt-[20px]">
                        ‘잘 만든 영상’을 ‘성과로 이어지는 광고 콘텐츠’로 바꿉니다.<br/>
                        영상의 본질은 유지하면서도, 광고에 필요한 구조와 메시지를 입힙니다.<br/>
                        <br/>
                        고객이 보유한 영상 자료에 <span
                        className={'font-[700]'}>분양의신만의 편집컷과 몰입아트를 더하고 시선이 머무르고 클릭이 일어나는 <br
                        className={'block md:hidden'}/>흐름을 구성합니다.</span><br/>
                        
                        영상의 길이, 시작 타이밍, 썸네일, 자막 위치까지 <span className={'font-[700]'}>모두 플랫폼별 송출 조건에 맞춰 최적화합니다.</span>
                    </Heading>
                </div>
                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">이 영상은 이런 곳에 사용됩니다.</h5>
                    <div className="px-[20px] mt-5 flex items-center justify-center  bg-[#F1F3F5] py-10 sm:mt-[20px] sm:py-[73px]">
                        <img className="h-auto max-w-full" src={BoxImg1} alt="CF 배너 활용 지면 예시" />
                    </div>
                    <p className="mt-5 text-base font-[400] leading-relaxed text-slate-800 sm:mt-[20px] sm:text-[18px]">
                        게재 위치가 달라지면, 영상의 구조도 달라집니다.<br/>
                        분양의신은 각 플랫폼과 지면에 맞춰 형태와 흐름을 설계합니다.
                    </p>
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">CF 배너 시리즈</h5>
                    <div className="mt-5 grid gap-x-2 gap-y-2 md:gap-x-6 md:gap-y-8  bg-[#F1F3F5] px-[18px] py-[24px] grid-cols-2 sm:mt-[20px] md:grid-cols-2 sm:px-10 sm:py-[38px] lg:px-[172px]">
                        <div className="flex flex-col items-center justify-center gap-3">
                            <video src={CfVideo1} autoPlay controls={false} muted loop playsInline className="h-auto w-full max-w-[240px] rounded-lg" />
                            <span className="text-sm font-[500] text-[#6B7684] sm:text-[16px]">퍼포먼스 X 배너</span>
                        </div>
                        <div className="flex flex-col items-center justify-center gap-3">
                            <video src={CfVideo2} autoPlay controls={false} muted loop playsInline className="h-auto w-full max-w-[240px] rounded-lg" />
                            <span className="text-sm font-[500] text-[#6B7684] sm:text-[16px]">브랜딩 X 배너</span>
                        </div>
                        <div className="flex flex-col items-center justify-center gap-3">
                            <video src={CfVideo3} autoPlay controls={false} muted loop playsInline className="h-auto w-full max-w-[240px] rounded-lg" />
                            <span className="text-sm font-[500] text-[#6B7684] sm:text-[16px]">퍼포먼스 부스터 배너</span>
                        </div>
                        <div className="flex flex-col items-center justify-center gap-3">
                            <video src={CfVideo4} autoPlay controls={false} muted loop playsInline className="h-auto w-full max-w-[240px] rounded-lg" />
                            <span className="text-sm font-[500] text-[#6B7684] sm:text-[16px]">브랜딩 부스터 배너</span>
                        </div>
                    </div>
                    <p className="mt-5 text-base font-[400] leading-relaxed text-slate-800 sm:mt-[20px] sm:text-[18px]">
                        분양의신 CF 배너는 총 4가지의 대표 포맷으로 운영됩니다. 하지만, 그 안에 수십 가지의 폼이
                        존재합니다.
                        같은 포맷이라도 지면에 따라 완전히 다른 영상이 되고 어떤 영상은 첫 3초의 임팩트가 중요하며, 어떤
                        영상은
                        감정 몰입형 구성이 더 효과적입니다.
                        우리는 단 하나의 영상이 아니라, 지면·길이·메시지에 따라 작동하는 수십 가지의 영상 폼을 설계합니다.
                    </p>
                </div>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">왜 분양의신에서 영상 콘텐츠를 제작해야 할까요?</h5>
                    <div className="mt-5 grid gap-3 bg-[#F1F3F5] px-6 py-8 sm:mt-[20px] sm:grid-cols-2 sm:gap-[13px] sm:px-[38px] sm:py-[38px]">
                        <div className="pl-[1rem] md:pl-0 flex w-full items-center justify-start md:justify-center gap-2 rounded-[6px] bg-white py-3">
                            <img src={WhyContentIcon1} alt="아트디자인팀 아이콘" />
                            <span className="text-[1rem] font-[400] text-black sm:text-[18px]">업계 최초 아트디자인팀 보유</span>
                        </div>
                        <div className="pl-[1rem] md:pl-0 flex w-full items-center justify-start md:justify-center gap-2 rounded-[6px] bg-white py-3">
                            <img src={WhyContentIcon2} alt="인하우스 제작 아이콘" />
                            <span className="text-[1rem] font-[400] text-black sm:text-[18px]">외주 없이 100% 인하우스 제작</span>
                        </div>
                        <div className="pl-[1rem] md:pl-0 flex w-full items-center justify-start md:justify-center gap-2 rounded-[6px] bg-white py-3">
                            <img src={WhyContentIcon3} alt="분양 현장 이해 아이콘" />
                            <span className="text-[1rem] font-[400] text-black sm:text-[18px]">분양 현장 이해도 기반 영상 기획</span>
                        </div>
                        <div className="pl-[1rem] md:pl-0 flex w-full items-center justify-start md:justify-center gap-2 rounded-[6px] bg-white py-3">
                            <img src={WhyContentIcon4} alt="자료 분석력 아이콘" />
                            <span className="text-[1rem] font-[400] text-black sm:text-[18px]">광고용으로 재가공 가능한 자료 분석력</span>
                        </div>
                        <div className="pl-[1rem] md:pl-0 flex w-full items-center justify-start md:justify-center gap-2 rounded-[6px] bg-white py-3 sm:col-span-2">
                            <img src={WhyContentIcon5} alt="AI 알고리즘 아이콘" />
                            <span className="text-[1rem] font-[400] text-black sm:text-[18px]">플랫폼별 AI 알고리즘 반영</span>
                        </div>
                    </div>
                    <p className="mt-5 text-base font-[400] leading-relaxed text-slate-800 sm:mt-[20px] sm:text-[18px]">
                        예쁜 영상은 많습니다. 성과로 이어지는 영상은 적습니다. 우리는 그 중 ‘움직이는 광고’를 만듭니다.
                    </p>
                </div>


                <CtaBanner
                    message="이미 있는 영상, 그냥 두기 아깝지 않으신가요?"
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default CfContentPage;
